module.exports = __webpack_public_path__ + "259baa445256a0bc926e973df1505e43.svg";